module.exports = __webpack_public_path__ + "static/media/logo_avianca.be7fdaae.svg";